export default __webpack_public_path__ + "static/media/left gun.b5c584a9.png";